import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';
import { DecisionModelWorkflow } from '@core/model/DecisionModelWorkflow';
import { map } from 'rxjs/operators';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { BankDto } from '@core/model/bank-dto';
import { routes } from '@model/constants/routes';

@Injectable({
  providedIn: 'root',
})
export class DisbursementAccountSelectionService {
  private apiGatewayUrl = environment.apiGatewayUrl;
  private getAllBanksUrl = `${this.apiGatewayUrl}${routes.getAllBanks}`;
  private bankAccountsMessageSource = new BehaviorSubject([]);
  accountsMessage$ = this.bankAccountsMessageSource.asObservable();

  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  public executeDecisionModel(decisionModelWorkflow: DecisionModelWorkflow, url: string): Observable<any> {
    return this.http.post(url, decisionModelWorkflow, {
      headers: this.headers,
    });
  }

  public getAllBanks(): Observable<any> {
    return this.http.get(this.getAllBanksUrl, { headers: this.headers }).pipe(
      map((response: BankDto[]) => {
        if (response) {
          return response.map((current) => {
            return {
              id: current.id,
              name: current.name.toUpperCase(),
              bancolombiaCode: current.bancolombiaCode,
              itauCode: current.itauCode,
              nit: current.nit,
              active: current.active,
            };
          });
        }
      })
    );
  }

  changeMessage(accounts: any) {
    this.bankAccountsMessageSource.next(accounts);
  }
}
